import EthereumQuery from './EthereumQuery.js';
import {SampleCreated} from './EthereumEvents.js';
import BackendQueryRunner from './BackendQueryRunner.js';

const runner = new BackendQueryRunner();

class BackendQuery extends EthereumQuery {
    constructor(address) {
        super(address);
    }

    /*
    async executeQuery() {
        let queries = [];
        for (let i in this.whereClauses) {
            let whereClause = this.whereClauses[i];
            let {valueList} = whereClause;
            if (valueList.length > 0) {
                for (let j in valueList) {
                    let query = this.getCopy();
                    query.whereClauses = this.whereClauses.filter(
                        x =>
                            x.value !== undefined);
                    query.where(whereClause.name, valueList[j]);
                    console.log('making of copy = ', this.getJson(), query.getJson());
                    queries.push(query);
                }
            } 
        }

        if (queries.length === 0) {
            return super.executeQuery();
        }
        console.log('queries = ', queries);

        let results  = [];
        for (let i in queries) {
            results = [... results, ... await queries[i].executeQuery(true)];;
        }
        return results;
    }
    */

    executeQuery(useBackend=true) { 
        return new Promise((resolve, reject) => {
            if (window.isNFT) {
                // thenn we dont have a query
                return resolve([]);
            }
            runner.submit(this.getJson())
                .then(resolve);
        });
    }
}

export default BackendQuery;
